import Grid from '@mui/material/Grid';

import { NoData } from '../Illustrations/NoData';
import { InfoAlert } from '../InfoAlert';

interface Props {
  readonly isInGroup: boolean;
}

export const EmptyServiceUsages = ({ isInGroup }: Readonly<Props>) =>
  isInGroup ? (
    <Grid size={12}>
      <InfoAlert>Aucune prestation dans ce groupe.</InfoAlert>
    </Grid>
  ) : (
    <NoData />
  );
